const Header = () => {
  return (
    <>
      <h1 className="font-semibold">Check Compatibility of two Avro Schemas</h1>
      <p className="text-gray-800">
        Apache Avro library is used under the hood to check whether schemas are
        forward- and/or backward- compatible.
      </p>
      <p className="text-gray-800 mb-2">
        Paste your Avro schemas below to compare and validate their
        compatibility easily. Expected format is either Avro schema or Avro
        protocol definition.
      </p>
    </>
  );
};

export default Header;
